import '../../common/css/style.css';

// Детальний опис груп (вік, рівень підготовки, стиль)
// • Розклад занять (якщо є фіксовані дати)
// • Що потрібно для занять (форма, взуття, вимоги)
// • Можливості участі в змаганнях, виступах

export const Groups = () => {
  return (
    <div id="groups" className="main-style">
      <div className="groups-wrapper">
        <h2 className="container-title">Групи 🤸</h2>

        <div className="groups-grid">
          <div className="group-card">
            <span className="group-card-icon">🧒</span>
            <h3 className="group-card-title">Дитяча хореографія</h3>
            <p>
              Ігровий підхід для наймолодших (від 3 років) — ритм,
              координація, естрадна та народна хореографія, перші виступи на
              сцені.
            </p>
          </div>

          <div className="group-card group-card-highlight">
            <span className="group-card-icon">🕺</span>
            <h3 className="group-card-title">Бальні танці</h3>
            <p>
              Європейська та латиноамериканська програми — від базової
              техніки до підготовки до змагань разом із чемпіонами та
              призерами турнірів.
            </p>
          </div>

          <div className="group-card group-card-soon">
            <span className="group-card-icon">💃</span>
            <h3 className="group-card-title">Танці для дорослих</h3>
            <p className="group-card-status">Coming soon</p>
          </div>
        </div>

        <p className="groups-note">
          📅 Розклад і рівень підготовки підберемо індивідуально — просто
          зв'яжіться з тренерами
        </p>
        <a href="/#contacts" className="cta-link">
          Обрати групу <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  );
};
